import { Component, Input, OnInit, input, model } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';
import { EditFireComponent } from 'src/app/routes/fire-tracker/edit-fire/edit-fire.component';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-view-forest-contacts',
    templateUrl: './view-forest-contacts.component.html',
    styleUrl: './view-forest-contacts.component.scss',
    standalone: false
})
export class ViewForestContactsComponent implements OnInit {

  faEdit = faEdit;
  edit_fire = model<boolean>();
  @Input() fire?: any;
  @Input() updateFireSubject?: Subject<any>;
  editable = input.required<boolean>();
  users: any[] = [];

  constructor(
    public dialog: MatDialog,
    private readonly userService: UserService,
  ) { }

  ngOnInit() {

    this.userService.getUserList("", ["baer_roles.baer_role"]).subscribe(data => {
      this.users = []
      data.users.forEach((user: any) => {
        // 4- Forest BAER Coordinator
        // 5-Forest BAR Coordinator
        user.isFOCO = user.baer_roles.filter((obj: any) => [4, 5].includes(obj.baer_role.value))?.map((x: any) => x.forest_name ?? user.forest_name) ?? [];
        if (!user.isFOCO) return
        let forests = this.fire.forest_name.split(",")
        user.isFOCO.forEach((forestRole: any) => {
          if (forests.includes(forestRole)) {
            this.users.push(user);
          }
        })
      })
    })
  }

  edit() {
    this.dialog.open(EditFireComponent, {
      maxWidth: "900px",
      panelClass: ['animate__animated', 'animate__fadeInDown'],
      data: {
        fireRecord: this.fire,
      },
    }).afterClosed().subscribe((reload: boolean) => {
      if (reload) {
        this.updateFireSubject?.next(null)
      }
    })
  }
}
